<template>
  <div class="custom-main custom-theme">
    <audio preload="load" id="voice">
      <source src="../../assets/audio/outpatient.mp3" type="audio/mp3"/>
    </audio>
    <a-form class="ant-advanced-search-form">
      <div class="gpws-menu-title">
        <span>&nbsp;</span>异常门诊
      </div>
      <a-row class="searchrow width-style-auto">
        <a-col span="7">
          <a-form-item :colon="false" label="就诊日期">
            <a-date-picker v-model="search.startDate" placeholder="请选择就诊开始日期" style="width: 120px;"/>至<a-date-picker v-model="search.endDate" placeholder="请选择就诊结束日期" style="width: 120px;"/>
          </a-form-item>
        </a-col>
        <a-col span="7">
          <a-form-item :colon="false" label="门诊机构">
            <a-select v-model="search.organId" allowClear show-search :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null" @search="handleOrganSearch" :dropdown-match-select-width="false" :dropdown-style="{'width': '250px'}">
              <a-select-option value="">--请选择--</a-select-option>
              <a-select-option v-for="item in init.organs" :key="item.oid" :value="item.oid">
                {{item.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col span="10">
          <a-form-item style="float: right;" :colon="false" label="关键字">
            <a-input v-model="search.keyword" placeholder="请输入患者姓名检索">
              <img class="search-btn" slot="addonAfter" src="../../assets/img/search.png" @click="searchAction"/>
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-row class="search"></a-row>
    <a-table size="middle" :columns="grid.columns" :loading="grid.loading" :rowSelection="{fixed:true}" rowKey="id" :dataSource="grid.data"
             :scroll="{ x: '100%' }" :pagination="grid.pagination" @change="gridChangeAction">
      <span slot="index" slot-scope="text, record, index">
        {{(((grid.pagination.current -1 ) * grid.pagination.pageSize) + index + 1) }}
      </span>
      <span slot="operate" slot-scope="text, record, index">
        <img src="../../assets/img/detail.png" style="cursor: pointer;margin-left: 12px;user-select: none;" @click="()=>detailAction(record.id)"/>
      </span>
    </a-table>
    <abnormal-outpatient-drawer ref="outpatientDrawer"/>
  </div>
</template>

<script>
import AbnormalOutpatientDrawer from "@/components/roam/AbnormalOutpatientDrawer";
export default {
  name: "AbnormalOutpatient",
  components: {AbnormalOutpatientDrawer},
  data() {
    return {
      loading: false,
      timeHandler:undefined,
      current: {},
      init:{
        organs:[],
        doctors:[]
      },
      search:{
        startDate:'',
        endDate:'',
        organId:'',
        keyword:''
      },
      grid: {
        loading: false,
        columns: columns,
        data: [],
        pagination: this.$pagination
      }
    }
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    },{
      text: "处方流转",
      path: ""
    },{
      text: "异常门诊",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  mounted() {
    let self = this;
    this.searchAction();

    this.timeHandler = window.setInterval(() => {
      self.searchAction();
    }, 120000);
  },
  beforeDestroy() {
    if(this.timeHandler){
      window.clearInterval(this.timeHandler);
    }
  },
  methods:{
    detailAction:function (id) {
      this.$refs.outpatientDrawer.showAction(id);
    },
    buildParams:function (){
      let startDate = '', endDate = '';
      if(undefined != this.search.startDate && null != this.search.startDate && '' != this.search.startDate){
        startDate = this.formatDate(new Date(this.search.startDate));
      }
      if(undefined != this.search.endDate && null != this.search.endDate && '' != this.search.endDate){
        endDate = this.formatDate(new Date(this.search.endDate));
      }

      return {
        'entity.organId' : this.search.organId, startTime : startDate, endTime : endDate, 'entity.keyword' : this.search.keyword
      };
    },
    /**
     * 查询按钮动作
     */
    searchAction: function () {
      Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
      let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 分页条操作
     */
    gridChangeAction: function (pagination, filters, sorter) {
      Object.assign(this.grid, {pagination: pagination});
      let params = Object.assign(this.buildParams(), {start: (pagination.current -1 ) * pagination.pageSize, length: pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 查询
     */
    loadGrid:function(params){
      const self = this;
      self.grid.loading = true;
      self.$axios.get('/api/clinic/abnormal/outpatients', {params: params}).then(function(res){
        self.grid.loading = false;
        if(res.msg.flag == 0){
          if(null == res.biz || res.biz.empty){
            self.$message.info({content: res.msg.message, duration: 2});
            Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
          }else{
            let voice = document.getElementById("voice");
            voice.currentTime = 0;
            voice.play();
            Object.assign(self.grid, {data: res.biz.data, pagination:Object.assign(self.grid.pagination, {total: res.biz.count})});
          }
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      },function(){
        self.grid.loading = false;
      });
    },
    //搜索医疗机构
    handleOrganSearch: function (value) {
      const self = this;
      this.init.organs = [];
      if (undefined != value && null != value && '' != value && value.length > 0) {
        this.$axios.get('/api/clinic/hospital/search', {params: {keyword: value}}).then(function (res) {
          if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            res.biz.forEach(function (e) {
              self.init.organs.push({id: e.id, name: e.name});
            });
          }
        }, function (res) {
        });
      }
    },
  }
}

const columns =[
  {
    title: '序号',
    align: 'center',
    scopedSlots: {customRender: 'index'},
    width: 60
  },
  {
    title: '门诊单号',
    dataIndex: 'code',
    key: 'code',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '患者姓名',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '性别',
    dataIndex: 'sex',
    key: 'sex',
    width: 80,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '年龄',
    dataIndex: 'age',
    key: 'age',
    width: 100,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '处方类型',
    dataIndex: 'model',
    key: 'model',
    align: 'center',
    width: 100,
    customRender:(text, record, index) =>{
      return record.model == null || record.model == undefined || record.model == '' ? '-' : (record.model == 'ROAM'?'流转处方':'本院处方');
    }
  },
  {
    title: '就诊机构',
    dataIndex: 'hospital',
    key: 'hospital',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '就诊时间',
    dataIndex: 'recipeTime',
    key: 'recipeTime',
    align: 'center',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '就诊科室',
    dataIndex: 'department',
    key: 'department',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '就诊医生',
    dataIndex: 'doctor',
    key: 'doctor',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '操作',
    key: 'id',
    align: 'center',
    fixed: 'right',
    width: 100,
    scopedSlots: {customRender: 'operate'}
  }
]
</script>

<style scoped>

</style>